import React from "react";
import { useSelector } from "react-redux";
import { Card, CardHeader, CardBody, Button } from "reactstrap";
import { Divider, Typography } from "antd";
import { Link } from "react-router-dom";
import Facts_page from "../Fact_List/index";
const { Text } = Typography;

const ChoiceFactIndex = () => {
  const lang_choiced = useSelector((state) => state.lang_change);

  return (
    <Card>
      <CardHeader className="text-center mb-4 h3">
        {lang_choiced.pages.choice_fact.title}
      </CardHeader>
      <CardBody>
        <p>
          <Text type="success">
          {lang_choiced.pages.choice_fact.help.title}
          </Text>
          {lang_choiced.pages.choice_fact.help.text}
          <Text code>
           +
          </Text>
        </p>
        <Divider />
        <Link to={"/add_fact"}>
          <Button color="info" className="m-2">
          {lang_choiced.pages.choice_fact.btnAddFact}
          </Button>
        </Link>
        {
          <Facts_page />
          // <br/><br/><br/><br/>
          // <NestedTable style={{ width: "100%", height: "100%" }} />
        }
      </CardBody>
    </Card>
  );
};

export default ChoiceFactIndex;
